import React from 'react'
import Ticker from 'react-ticker'

import BlockContent from '../shared/blockContent'
import './clientsList.css'

const ClientsList = ({ data }) => {
  return (
    <section className="clientsList">
      <div className="inner">
        <h2>{data.title}</h2>
        {data.text && <BlockContent input={data.text} />}
        <Ticker>
          {() => data.clients && data.clients.map((client, index) => `${client} — `).join('')}
        </Ticker>
      </div>
    </section>
  )
}

export default ClientsList
